module.exports = __webpack_public_path__ + "img/progressDataImgUpdated.972f613b.svg";